import React, { createContext, useContext, ReactNode } from 'react';
import { UseStepNavigationReturn } from '@hooks/scenarios-simulator/business/use-step-navigation';

const StepNavigationContext = createContext<UseStepNavigationReturn | null>(null);

interface StepNavigationProviderProps {
  children: ReactNode;
  value: UseStepNavigationReturn;
}

export function StepNavigationProvider({ children, value }: StepNavigationProviderProps) {
  return <StepNavigationContext.Provider value={value}>{children}</StepNavigationContext.Provider>;
}

export type StepNavigationContextValue = UseStepNavigationReturn;

/**
 * Hook to access step navigation state across the simulator.
 * Ensures all components (header, footer, form, etc.) speak the same language.
 *
 * @throws Error if used outside StepNavigationProvider
 */
export function useStepNavigationContext(): StepNavigationContextValue {
  const context = useContext(StepNavigationContext);

  if (!context) {
    throw new Error('useStepNavigationContext must be used within StepNavigationProvider');
  }

  return context;
}
